import { Dayjs } from 'dayjs';

export interface MonthItem {
  key: string;
  year: number;
  month: number;
  label: string;
  date: Dayjs;
}

export const getMonthsInRange = (startDate: Dayjs, endDate: Dayjs): MonthItem[] => {
  const months: MonthItem[] = [];

  let current = endDate.startOf('month');
  const start = startDate.startOf('month');

  while (current.isSameOrAfter(start, 'month')) {
    months.push({
      key: current.format('YYYY-MM'),
      year: current.year(),
      month: current.month(),
      label: current.format('MMMM YYYY'),
      date: current,
    });
    current = current.subtract(1, 'month');
  }

  return months;
};
